import {SagaIterator} from "redux-saga";
import {all, takeLatest} from "redux-saga/effects";
import {
	changeAvatar,
	changePassword,
	forgotPassword,
	login,
	logout,
	navigateToRedirectUri,
	nonAuthRedirect,
	recoveryPassword,
	register,
	requestAchievements,
	requestAvatars,
	requestCountries,
	requestHelpPages,
	requestLandingData,
	requestSettings,
	requestTeams,
	requestUser,
	requestUserAchievements,
	updateUser,
	validateToken,
} from "modules/actions";
import {
	changeAvatarSaga,
	changePasswordSaga,
	forgotPasswordSaga,
	loginSaga,
	logoutSaga,
	navigateToRedirectUriSaga,
	nonAuthRedirectSaga,
	recoveryPasswordSaga,
	registerSaga,
	requestAchievementsSaga,
	requestAvatarsSaga,
	requestCountriesSaga,
	requestHelpPagesSaga,
	requestLandingDataSaga,
	requestSettingsSaga,
	requestTeamsSaga,
	requestUserAchievementsSaga,
	requestUserSaga,
	updateUserSaga,
	validateTokenSaga,
} from "modules/sagas";

/**
 * Root saga that connect sagas with actions.
 */
export const rootSaga = function* (): SagaIterator {
	yield all([
		/**
		 * JSON
		 */
		takeLatest(requestSettings, requestSettingsSaga),
		takeLatest(requestTeams, requestTeamsSaga),
		takeLatest(requestHelpPages, requestHelpPagesSaga),
		takeLatest(requestAvatars, requestAvatarsSaga),
		takeLatest(requestAchievements, requestAchievementsSaga),
		takeLatest(requestCountries, requestCountriesSaga),
		/**
		 * Auth
		 */
		takeLatest(login, loginSaga),
		takeLatest(register, registerSaga),
		takeLatest(forgotPassword, forgotPasswordSaga),
		takeLatest(recoveryPassword, recoveryPasswordSaga),
		takeLatest(validateToken, validateTokenSaga),
		takeLatest(logout, logoutSaga),
		takeLatest(nonAuthRedirect, nonAuthRedirectSaga),
		/**
		 * User
		 */
		takeLatest(requestUser, requestUserSaga),
		takeLatest(updateUser, updateUserSaga),
		takeLatest(changePassword, changePasswordSaga),
		takeLatest(changeAvatar, changeAvatarSaga),
		/**
		 * Achievements
		 */
		takeLatest(requestUserAchievements, requestUserAchievementsSaga),
		/**
		 * Landing
		 */
		takeLatest(requestLandingData, requestLandingDataSaga),
		/**
		 * Navigate
		 */
		takeLatest(navigateToRedirectUri, navigateToRedirectUriSaga),
	]);
};

export * from "./json";
export * from "./auth";
export * from "./navigate";
export * from "./userAchievements";
export * from "./landing";
export * from "./user";
